import { combineReducers } from '@reduxjs/toolkit'
import authenticationReducer from './authentication'
import infoReducer from './info'

export default combineReducers({
  authentication: authenticationReducer,
  info: infoReducer,
})
